import TableGridWithFilters from '../components/tableComponents/TableGridWithFilters';
import React, { useEffect, useState } from 'react';
import { moneyCatalogColumns } from '../components/moneyCatalog/moneyCatalogColumns';
import { moneyCatalogFields } from '../components/moneyCatalog/moneyCatalogFilters';
import DownloadButton from '../components/downloadButton';
import { useAuthContext } from '../context/AuthContext';
import axios from 'axios';

const MoneyCatalog = () => {
  const { loading, setLoading } = useAuthContext();
  const [selectOptionsYear, setSelectOptionsYear] = useState([]);
  const [filtersValues, setFiltersValues] = useState([]);

  useEffect(() => {
    const getFilterArrays = async () => {
      try {
        setLoading(true);
        const response = await axios.get(
          `${process.env.REACT_APP_BACKEND_URL}/getListOfYears`,
          {
            withCredentials: true,
          },
        );

        const _dataYears = response.data.years?.map((year) => ({
          key: year,
          value: year,
        }));

        setSelectOptionsYear(_dataYears);
      } catch (error) {
        console.error('Error fetching years:', error);
      } finally {
        setLoading(false);
      }
    };

    getFilterArrays();
  }, [setLoading]);

  return (
    <>
      <section className='app-container'>
        <div
          style={{
            marginBottom: 5,
            margin: '0 auto',
            width: '75vw',
            paddingBottom: '3em',
          }}
        >
          <h2>Προβολή Χρηματικών Καταλόγων</h2>
          <TableGridWithFilters
            columns={moneyCatalogColumns}
            initialValues={{ year: '', status: '' }}
            filterFields={moneyCatalogFields({ selectOptionsYear })}
            paginationMode='server'
            fetchUrl={`${process.env.REACT_APP_BACKEND_URL}/TotalDataMoneyCatalog`}
            style={{ width: '100%', flex: 1 }}
            onFiltersChange={(filters) => {
              setFiltersValues(filters);
            }}
          />

          <DownloadButton
            downloadUrl={`${
              process.env.REACT_APP_BACKEND_URL
            }/downloadMoneyCatalog?${
              filtersValues.year
                ? `year=${filtersValues.year}&`
                : ''
            }${filtersValues.status
              ? `status=${filtersValues.status}&`
              : ''}`}
            filename='Λίστα'
            buttonText='Λήψη Αρχείου'
            disabled={loading}
          />
        </div>
      </section>
    </>
  );
};

export default MoneyCatalog;
